import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Bilans from './pages/Bilans';
import Adherents from './pages/Adherents';
import Users from './pages/Users';
import Configuration from './pages/Configuration';
import BilanDetail from './pages/BilanDetail';
import Classements from './pages/Classements';
import Journal from './pages/Journal';
import Layout from './components/Layout';
import { AuthProvider, useAuth } from './context/AuthContext';

function PrivateRoute({ children, roles }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" />;
  return children;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" /> : <Login />} />
      <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
        <Route index element={<Dashboard />} />
        <Route path="bilans" element={<Bilans />} />
        <Route path="bilans/:id" element={<BilanDetail />} />
        <Route path="classements" element={<Classements />} />
        <Route path="adherents" element={
          <PrivateRoute roles={['GESTIONNAIRE', 'ADMIN']}><Adherents /></PrivateRoute>
        } />
        <Route path="users" element={
          <PrivateRoute roles={['GESTIONNAIRE', 'ADMIN']}><Users /></PrivateRoute>
        } />
        <Route path="configuration" element={
          <PrivateRoute roles={['ADMIN']}><Configuration /></PrivateRoute>
        } />
        <Route path="journal" element={
          <PrivateRoute roles={['ADMIN']}><Journal /></PrivateRoute>
        } />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}
